module.exports = __webpack_public_path__ + "static/1-b8a8e41bdf67423ddba3bfda32aa2079.png";